import { Card, CardContent } from "@/components/ui/card";
import { Calendar, Truck, CheckCircle, Star } from "lucide-react";
import { processSteps } from "@/config/contentConfig";

const stepIcons = [
  <Calendar className="w-6 h-6" />,
  <Truck className="w-6 h-6" />,
  <CheckCircle className="w-6 h-6" />,
  <Star className="w-6 h-6" />
];

export const ProcessSteps = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
      {processSteps.map((item, index) => (
        <Card key={index} className="text-center p-6 hover:shadow-card transition-all duration-300">
          <CardContent className="pt-6">
            <div className="w-16 h-16 gradient-primary rounded-full flex items-center justify-center mx-auto mb-4 text-white">
              <span className="text-2xl font-bold">{item.step}</span>
            </div>
            <h3 className="text-xl font-display font-semibold mb-3">{item.title}</h3>
            <p className="text-muted-foreground leading-relaxed">{item.description}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};